import { useState } from "react"
import { apiJSONURL } from "../../../App"
import { useGlobalContext } from "../../data/GlobalContext"

export default function WithdrawalPin() {
  const { username, playerDetails } = useGlobalContext()
  const [currentPin, setCurrentPin] = useState("")
  const [newPin, setNewPin] = useState("")
  const [newPin2, setNewPin2] = useState("")
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [pinVisible, setPinVisible] = useState(false)
  const [newPinVisible, setNewPinVisible] = useState(false)
  const [newConfirmPinVisible, setNewConfirmPinVisible] = useState(false)
  const isLoggedIn = Boolean(username)

  const getPin = playerDetails?.pin

  // Ensure only numeric input
  const handleNumericInput = (value) => value.replace(/[^0-9]/g, "")

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!isLoggedIn) return

    setMessage("Processing...")
    setLoading(true)

    // Validation for current withdrawal pin
    if (!currentPin) {
      setMessage("Please fill in the current pin")
      setLoading(false)
      setTimeout(() => setMessage(""), 10000)
      return
    }
    if (currentPin !== getPin) {
      setMessage(
        "The current withdrawal pin you entered does not match our records."
      )
      setLoading(false)
      setTimeout(() => setMessage(""), 10000)
      return
    }

    // Validation for new withdrawal pin
    if (!newPin) {
      setMessage("Please fill in the new pin")
      setLoading(false)
      setTimeout(() => setMessage(""), 10000)
      return
    }
    if (!newPin2) {
      setMessage("Please fill in the confirm new pin")
      setLoading(false)
      setTimeout(() => setMessage(""), 10000)
      return
    }
    if (newPin.length < 4) {
      setMessage("Your new pin is too short; it must be 4 characters")
      setLoading(false)
      setTimeout(() => setMessage(""), 10000)
      return
    }
    if (newPin !== newPin2) {
      setMessage("New pin and confirm new pin do not match!")
      setLoading(false)
      setTimeout(() => setMessage(""), 10000)
      return
    }

    // Prepare form data for the API
    const formData = new URLSearchParams()
    formData.append("cmd", "changePin")
    formData.append("u", username)
    formData.append("pin", newPin)

    try {
      const response = await fetch(apiJSONURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      })

      const data = await response.json()
      if (data.s) {
        setCurrentPin("")
        setNewPin("")
        setNewPin2("")
        setMessage("Your withdrawal pin has been changed successfully.")
      } else {
        setMessage(data.e || "An error occurred.")
      }
    } catch (error) {
      console.error("Error submitting form:", error)
      setMessage("An error occurred, please try again.")
    } finally {
      setLoading(false)
      setTimeout(() => {
        setMessage("")
      }, 10000)
    }
  }

  return (
    <div className="change-pin-container">
      <div className="change-pin-container--notice">
        If you forget your withdrawal pin, contact our FGH 24/7 customer support
        for assistance, and you will be asked to complete our KYC verification.
      </div>
      <form onSubmit={handleSubmit}>
        <div className="password-field">
          <input
            type={pinVisible ? "text" : "password"}
            placeholder="Current Withdrawal Pin"
            value={currentPin}
            onChange={(e) => setCurrentPin(handleNumericInput(e.target.value))}
            autoComplete="off"
            inputMode="numeric"
            maxLength="4"
          />
          <span onClick={() => setPinVisible(!pinVisible)}>
            {pinVisible ? (
              <img
                src="/images/icon/hide-password.webp"
                alt="Hide Password"
                className="password-icon-status"
              />
            ) : (
              <img
                src="/images/icon/reveal-password.webp"
                alt="Show Password"
                className="password-icon-status"
              />
            )}
          </span>
        </div>
        <div className="password-field">
          <input
            type={newPinVisible ? "text" : "password"}
            placeholder="New Withdrawal Pin"
            value={newPin}
            onChange={(e) => setNewPin(handleNumericInput(e.target.value))}
            autoComplete="off"
            inputMode="numeric"
            maxLength="4"
          />
          <span onClick={() => setNewPinVisible(!newPinVisible)}>
            {newPinVisible ? (
              <img
                src="/images/icon/hide-password.webp"
                alt="Hide Password"
                className="password-icon-status"
              />
            ) : (
              <img
                src="/images/icon/reveal-password.webp"
                alt="Show Password"
                className="password-icon-status"
              />
            )}
          </span>
        </div>
        <div className="password-field">
          <input
            type={newConfirmPinVisible ? "text" : "password"}
            placeholder="Confirm Withdrawal Pin"
            value={newPin2}
            onChange={(e) => setNewPin2(handleNumericInput(e.target.value))}
            autoComplete="off"
            inputMode="numeric"
            maxLength="4"
          />
          <span onClick={() => setNewConfirmPinVisible(!newConfirmPinVisible)}>
            {newConfirmPinVisible ? (
              <img
                src="/images/icon/hide-password.webp"
                alt="Hide Password"
                className="password-icon-status"
              />
            ) : (
              <img
                src="/images/icon/reveal-password.webp"
                alt="Show Password"
                className="password-icon-status"
              />
            )}
          </span>
        </div>

        {message && <div className="change-pin-msg">{message}</div>}
        <div className="change-pass-container">
          <button
            className={`change-password-btn ${
              currentPin.trim() === "" ||
              newPin.trim() === "" ||
              newPin2.trim() === ""
                ? "disabled"
                : ""
            }`}
            type="submit"
            disabled={
              currentPin.trim() === "" ||
              newPin.trim() === "" ||
              newPin2.trim() === "" ||
              loading
            }
          >
            {loading ? "Processing..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  )
}
